module.exports = __webpack_public_path__ + "static/media/success.a52ff0f2.lottie";